<div class="text-editor">
    <editor [(ngModel)]="editorContent" [init]="init"/>
</div>